export const networkMenuChildren = () => {
  return [
    {
      id: 'job',
      title: 'jobs',
      icon: 'place',
      link: '/job/search',
      type: 'collapsable',
      securityFunctions: ['JOB:read'],

      children: [
        {
          id: 'job.search',
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/job/search',
          exactMatch: true,
          securityFunctions: ['JOB_SEARCH:read'],
        },
        {
          id: 'job.active',
          title: 'activeJobs',
          type: 'basic',
          icon: 'stream',
          link: '/job/active',
          securityFunctions: ['JOB_ACTIVITY:read'],
        },
        {
          id: 'job.reviews',
          title: 'reviews',
          type: 'basic',
          icon: 'grading',
          link: '/job/reviews',
          exactMatch: true,
          securityFunctions: ['JOB_SEARCH:read'],
        },
        {
          id: 'job.new',
          title: 'newJob',
          type: 'basic',
          icon: 'add',
          link: '/job/new',
          securityFunctions: ['JOB_DETAIL:create'],
        },
        {
          id: 'job.edit',
          title: 'editJob',
          type: 'basic',
          hidden: () => hideItem(),
          link: '/job',
          securityFunctions: ['JOB_DETAIL:update'],
          classes: { wrapper: 'hidden' },
        },
      ],
    },
    {
      id: 'route-plan',
      title: 'routePlanning',
      icon: 'route',
      link: '/route-planning',
      type: 'collapsable',
      securityFunctions: ['ROUTE_PLAN:read', 'ROUTE_PLAN_SEARCH:read'],

      children: [
        {
          id: 'route-plan.search',
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/route-planning/search',
          exactMatch: true,

          securityFunctions: ['ROUTE_PLAN_SEARCH:read'],
        },

        {
          id: 'route-plan.new',
          title: 'newPlan',
          type: 'basic',
          icon: 'add',
          link: '/route-planning/new',

          securityFunctions: ['ROUTE_PLAN:create'],
        },
      ],
    },
    {
      id: 'driver',
      title: 'drivers',
      icon: 'person',
      link: '/driver',
      type: 'collapsable',
      securityFunctions: ['DRIVER:read'],

      children: [
        {
          id: 'driver.search',
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/driver/search',
          exactMatch: true,
          securityFunctions: ['DRIVER_SEARCH:read'],
        },
        {
          title: 'reviews',
          type: 'basic',
          icon: 'grading',
          link: '/driver/reviews',
          exactMatch: true,
          securityFunctions: ['DRIVER_REVIEW:read'],
        },
      ],
    },
    // {
    //   id: 'shift',
    //   title: 'shifts',
    //   icon: 'schedule',
    //   link: '/shift/search',
    //   type: 'collapsable',
    //   securityFunctions: [
    //     'DRIVER_SHIFT_SEARCH:read',
    //     'VEHICLE_SHIFT_SEARCH:read',
    //   ],
    //   children: [
    //     {
    //       id: 'shift.search',
    //       title: 'search',
    //       type: 'basic',
    //       icon: 'search',
    //       link: '/shift/search',
    //       exactMatch: true,
    //       securityFunctions: ['DRIVER_SHIFT_SEARCH:read'],
    //     },
    //     {
    //       id: 'shift.reporting',
    //       title: 'reporting',
    //       type: 'basic',
    //       icon: 'assessment',
    //       link: '/shift/reporting',
    //       exactMatch: true,
    //       fleetOnly: true,
    //       securityFunctions: ['DRIVER_SHIFT_SEARCH:read'],
    //     },
    //   ],
    // },

    {
      id: 'operator',
      title: 'operators',
      icon: 'supervised_user_circle',
      link: '/operator/search',
      securityFunctions: ['OPERATOR:read'],

      type: 'collapsable',
      children: [
        {
          id: 'operator.search',
          title: 'search',
          link: '/operator/search',
          icon: 'search',
          type: 'basic',
          securityFunctions: ['OPERATOR_SEARCH:read'],
        },
        {
          id: 'operator.invoice',
          title: 'invoices',
          link: '/operator/invoices',
          icon: 'request_quote',
          type: 'basic',
          securityFunctions: ['OPERATOR_INVOICE_SEARCH:read'],
        },
      ],
    },
    {
      id: 'organisation',
      title: 'organisation',
      icon: 'business',
      link: '/organisation/search',
      securityFunctions: ['ORGANISATION:read'],
      type: 'collapsable',
      children: [
        {
          id: 'organisation.search',
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/organisation/search',
          exactMatch: true,
          securityFunctions: ['ORGANISATION_SEARCH:read'],
        },
      ],
    },
    {
      id: 'traveller',
      title: 'travellers',
      icon: 'hail',
      link: '/traveller',
      type: 'collapsable',
      securityFunctions: ['TRAVELLER:read'],

      exactMatch: false,
      children: [
        {
          id: 'traveller.search',
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/traveller/search',
          exactMatch: true,
          securityFunctions: ['TRAVELLER_SEARCH:read'],
        },
      ],
    },
    {
      id: 'vehicle',
      title: 'vehicles',
      icon: 'local_taxi',
      securityFunctions: ['VEHICLE:read'],

      link: '/vehicle',
      type: 'collapsable',
      exactMatch: false,
      children: [
        {
          id: 'vehicle.search',
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/vehicle/search',
          exactMatch: true,
          securityFunctions: ['VEHICLE_SEARCH:read'],
        },

        {
          id: 'vehicle.fleet',
          title: 'activeVehicles',
          type: 'basic',
          icon: 'radar',
          link: '/vehicle/fleet',
          exactMatch: true,
          securityFunctions: ['VEHICLE_ACTIVE_SEARCH:read'],
        },
        {
          id: 'position',
          title: 'positionSearch',
          type: 'basic',
          icon: 'share_location',
          link: '/position',
          securityFunctions: ['POSITION_SEARCH:read'],
        },
        {
          id: 'medallion',
          title: 'medallions',
          type: 'basic',
          icon: 'shield_with_house',
          link: '/vehicle/medallion',
          securityFunctions: ['MEDALLION_SEARCH:read'],
        },
        {
          id: 'vehicle.insurance',
          title: 'insurance',
          type: 'basic',
          icon: 'history_edu',
          link: '/vehicle/insurance',
          securityFunctions: ['INSURANCE_POLICY_SEARCH:read'],
        },
      ],
    },

    {
      title: 'leases',
      type: 'collapsable',
      icon: 'real_estate_agent',
      id: 'lease',
      link: '/lease',
      securityFunctions: ['LEASE_SEARCH:read'],
      children: [
        {
          title: 'reservationSearch',
          type: 'basic',
          icon: 'heroicons_outline:calendar',
          link: '/lease/reservations',
          securityFunctions: ['LEASE_SEARCH:read'],
        },
        {
          title: 'search',
          type: 'basic',
          icon: 'search',
          link: '/lease/search',
          securityFunctions: ['LEASE_SEARCH:read'],
        },
        {
          title: 'newReservation',
          type: 'basic',
          icon: 'add',
          link: '/lease/reservations/create',
          securityFunctions: ['LEASE_DETAIL:create'],
        },
      ],
    },
    {
      title: 'hardware',
      type: 'collapsable',
      icon: 'devices',
      id: 'hardware',
      link: '/hardware',
      securityFunctions: ['HARDWARE:read'],

      children: [
        {
          title: 'assets',
          type: 'basic',
          icon: 'heroicons_outline:device-mobile',
          link: '/hardware/asset',
          id: 'hardware.asset',
          securityFunctions: ['HARDWARE_ASSET_SEARCH:read'],
        },
        {
          title: 'orders',
          type: 'basic',
          icon: 'heroicons_outline:clipboard-list',
          link: '/hardware/order',
          id: 'hardware.order',
          securityFunctions: ['HARDWARE_ORDER_SEARCH:read'],
        },
        {
          title: 'shipments',
          type: 'basic',
          icon: 'heroicons_outline:truck',
          link: '/hardware/shipment',
          id: 'hardware.shipment',
          securityFunctions: ['HARDWARE_SHIPMENT_SEARCH:read'],
        },
        {
          title: 'returnAuthorisations',
          type: 'basic',
          icon: 'heroicons_outline:clipboard-check',
          link: '/hardware/return-authorisation',
          id: 'hardware.returns',
          securityFunctions: ['HARDWARE_RETURN_AUTHORISATION_SEARCH:read'],
        },
      ],
    },

    {
      id: 'finance',
      title: 'finance',
      icon: 'account_balance',

      type: 'collapsable',
      securityFunctions: ['FINANCE:read'],

      children: [
        {
          title: 'remittances',
          type: 'collapsable',
          icon: 'heroicons_outline:currency-dollar',
          id: 'finance',
          securityFunctions: ['FINANCE_REMITTANCES:read'],
          children: [
            {
              title: 'search',
              type: 'basic',
              icon: 'heroicons_outline:search',
              link: '/finance/remittance/search',
              id: 'disbursement.search',
              securityFunctions: ['FINANCE_REMITTANCE_SEARCH:read'],
            },
            {
              title: 'batches',
              type: 'basic',
              icon: 'heroicons_outline:clipboard-list',
              link: '/finance/remittance/batches',
              id: 'disbursement.batches',
              securityFunctions: ['FINANCE_REMITTANCE_BATCH:read'],
            },
          ],
        },

        {
          title: 'directDebits',
          type: 'collapsable',
          icon: 'heroicons_outline:cash',
          id: 'direct-debit',
          securityFunctions: ['FINANCE_DIRECT_DEBITS:read'],
          children: [
            {
              title: 'search',
              type: 'basic',
              icon: 'heroicons_outline:search',
              link: '/direct-debit/search',
              id: 'direct-debit.search',
              exactMatch: true,
              securityFunctions: ['FINANCE_DIRECT_DEBIT_SEARCH:read'],
            },
            {
              title: 'batches',
              type: 'basic',
              icon: 'heroicons_outline:clipboard-list',
              link: '/direct-debit/batches',
              id: 'direct-debit.batches',
              exactMatch: true,
              securityFunctions: ['FINANCE_DIRECT_DEBIT_BATCH:read'],
            },
          ],
        },
        {
          title: 'cabchargeImport',
          type: 'basic',
          icon: 'heroicons_outline:arrow-up-on-square-stack',
          link: '/cabcharge',
          id: 'import.cabcharge',
          securityFunctions: ['CABCHARGE_IMPORT_ADMIN:read'],
        },
      ],
    },

    {
      id: 'notifications',
      title: 'notifications',
      icon: 'notifications',
      link: '/notification/search',
      exactMatch: false,
      type: 'basic',
      securityFunctions: ['NOTIFICATIONS:read'],
    },
    {
      title: 'calls',
      type: 'basic',
      icon: 'heroicons_outline:phone',
      link: '/calls',

      securityFunctions: ['CALL:read'],
    },
    {
      id: 'duress',
      title: 'duress',
      type: 'basic',
      icon: 'crisis_alert',
      link: '/duress',
      securityFunctions: ['DURESS_SEARCH:read'],
    },
    {
      id: 'tools',

      title: 'tools',
      type: 'collapsable',
      icon: 'hardware',
      link: '/geo-tools',
      fleetOnly: true,
      children: [
        // {
        //   title: 'Positions',
        //   type: 'basic',
        //   icon: 'pin_drop',
        //   link: '/geo-tools/position',
        // },
        {
          title: 'isochrones',
          type: 'basic',
          icon: 'radar',
          link: '/geo-tools/isochrone',
          fleetOnly: true,
        },
        // {
        //   title: 'Boundaries',
        //   type: 'basic',
        //   icon: 'map',
        //   link: '/geo-tools/boundary',
        // },
        {
          title: 'tolls',
          type: 'basic',
          icon: 'toll',
          link: '/geo-tools/toll',
          fleetOnly: true,
        },
        {
          title: 'polyline',
          type: 'basic',
          icon: 'bolt',
          link: '/geo-tools/polyline',
          fleetOnly: true,
        },
        {
          title: 'offlineActions',
          type: 'basic',
          icon: 'offline_bolt',
          link: '/offline-job-action',
          securityFunctions: ['OFFLINE_JOB_ACTIONS:read'],
          fleetOnly: true,
        },
      ],
    },
    {
      title: 'settings',
      type: 'collapsable',
      icon: 'heroicons_outline:cog',
      id: 'group.settings',
      // link: '/settings',
      securityFunctions: [
        'NETWORK_INTEGRATIONS:read',
        'NETWORK_BRAND:read',
        'NETWORK_CONFIGURATION_SETTINGS:read',
        'NETWORK_SECURITY_USERS:read',
        'NETWORK_SECURITY_ROLES:read',
        'NETWORK_SECURITY_MFA:read',
        'NETWORK_DISPATCH:read',
        'NETWORK_MANAGEMENT:read',
        'PROMOTIONS:read',
      ],

      children: [
        {
          title: 'security',
          type: 'basic',
          icon: 'heroicons_outline:shield-check',
          link: '/settings/security',
          id: 'group.security',
          securityFunctions: ['NETWORK_SECURITY:read'],
        },
        {
          title: 'dispatch',
          type: 'basic',
          icon: 'heroicons_outline:clipboard-list',
          link: '/settings/area',
          id: 'group.dispatch',
          securityFunctions: ['NETWORK_DISPATCH:read'],
        },
        {
          title: 'management',
          type: 'basic',
          icon: 'heroicons_outline:clipboard',
          link: '/settings/management',
          id: 'group.management',
          securityFunctions: ['NETWORK_MANAGEMENT:read'],
        },
        {
          title: 'promotions',
          type: 'basic',
          icon: 'heroicons_outline:sparkles',
          link: '/settings/promotion',
          id: 'group.promotion',
          securityFunctions: ['PROMOTIONS:read'],
        },
        {
          title: 'training',
          type: 'basic',
          icon: 'school',
          link: '/learning',
          id: 'training',
          securityFunctions: ['COURSE:read'],
        },
        {
          title: 'integrations',
          type: 'basic',
          icon: 'hub',
          link: '/settings/integration',
          id: 'group.integration',
          securityFunctions: ['NETWORK_INTEGRATIONS:read'],
        },
        {
          title: 'brand',
          type: 'basic',
          icon: 'style',
          link: '/settings/brand',
          id: 'brand',
          securityFunctions: ['NETWORK_BRAND:read'],
        },

        {
          title: 'tollConfiguration',
          type: 'basic',
          icon: 'table_rows',
          link: '/settings/tollway',
          fleetOnly: true,
        },
        {
          title: 'configuration',
          type: 'basic',
          icon: 'settings',
          link: '/settings/configuration',
          id: 'configuration',
          securityFunctions: ['NETWORK_CONFIGURATION_SETTINGS:read'],
        },
      ],
    },
    {
      title: 'signOut',
      type: 'basic',
      icon: 'heroicons_outline:logout',
      link: '/auth/logout',
      id: 'signout',
    },
  ];
};

export const networkNavigation = () => [
  {
    type: 'group',
    children: networkMenuChildren(),
  },
];

export const networkNavigationNoGroups = () => [
  {
    type: 'group',
    children: networkMenuChildren().filter((s) => s.id !== 'network-group'),
  },
];

export const hideItem = () => {
  return true;
};
